
        var result = require("!!../../../../node_modules/css-loader/index.js!./benefits.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/benefits/benefits.component.css
// module id = 543
// module chunks = 0